const removeQueryParamFromUri = name => {
  const uri = window.location.href
  const storeIDIndex = uri.indexOf(name)
  const newUri =
    uri.substr(0, storeIDIndex) +
    (uri.substr(storeIDIndex).indexOf('&') > -1
      ? uri.substr(storeIDIndex + 1 + uri.substr(storeIDIndex).indexOf('&'))
      : '')
  window.history.replaceState('', '', newUri.replace(window.location.origin, ''))
}

export default removeQueryParamFromUri
